import React from "react";
import "./VerifyEmailContainer.css";
import {verifyEmail}  from "utilities/js/callouts/CalloutFactory";
import getURLParam from "utilities/js/ParameterRetrieval";
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import BracksetFooter from "components/reusable/BracksetFooter";
import BracksetHeader from "components/reusable/BracksetHeader";
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";
import Constants from "utilities/js/Constants";

const loadingIcon = Constants.ICON_LOADING;

class VerifyEmailContainer extends React.Component {

  constructor(props){
    super(props);
    let token = getURLParam('token')
    this.state = {
      token: token,
      isLoading: true,
      isError: false,
      errorMessage: "There was a problem verifying your email",
      verified: false //Really just added this for Strict Mode because componentDidMount was being called twice
    };

    this.displayContent = this.displayContent.bind(this);
    this.navigateToLandingPage = this.navigateToLandingPage.bind(this);
  }

  componentDidMount(){
    verifyEmail(this.state.token).then(response => {
      this.setState({isError: false, verified: true});
    }).catch(error => {
        if(!this.state.verified){
            if(error.code){
                this.setState({errorMessage: error.message, isError: true})
            }else{
                this.setState({isError: true});
            }
        }
    }).finally(() => {
      this.setState({isLoading: false});
    });
  }

  navigateToLandingPage(){
    navigateToLandingPage({routerNav: this.props.navigate})
  }

  displayContent(){
    if(this.state.isError){
      return (<>
        <div>
          <div className="verify-email-header">Something went wrong...</div><div className="verify-email-error">{this.state.errorMessage}</div>
        </div>
      </>)
    }else{
      return (<>
        <div>
          <div className="verify-email-header">Success!</div><div className="verify-email-success">Your email was verified.  Click <a href="/">here</a> to navigate to the home page</div>
        </div>
      </>)
    }
  }

  render(){
    let content = (<div className="loading-icon-container"><img src={loadingIcon} alt="loading"></img></div>)
    if(!this.state.isLoading){
      content = (<>{this.displayContent()}</>);
    }

    return (
      <div className="brackset-container">
            <BracksetHeader hideSearch="true"></BracksetHeader>
            <div className="email-verify-centered">
                {content}
                <div className="landing-nav-buttons">
                    <div className="nav-button-container home">
                        <button className="nav-button-white" onClick={this.navigateToLandingPage}>Return Home</button>
                    </div>
                </div>
            </div>
        <BracksetFooter></BracksetFooter>
      </div>
    )

  }
}

export default NavigatorWrapper(VerifyEmailContainer);
